<template>
  <div class="comment-page">
    <top-bar :topbarList="cardCouponTopBarList"></top-bar>
    <router-view></router-view>
  </div>
</template>

<script>
import topBar from "@/components/topBar.vue";

import { cardCouponIndexMixins } from "@/mixins/cardCouponIndexMixins";

export default {
  mixins: [cardCouponIndexMixins],
  data() {
    return {};
  },
  computed: {},
  components: {
    topBar,
  },
};
</script>

<style lang="less" scoped>
.comment-page {
  height: 100%;
}
</style>
